import { render, staticRenderFns } from "./MissingInfoForm.vue?vue&type=template&id=601e2d78&scoped=true"
import script from "./MissingInfoForm.vue?vue&type=script&lang=js"
export * from "./MissingInfoForm.vue?vue&type=script&lang=js"
import style0 from "./MissingInfoForm.vue?vue&type=style&index=0&id=601e2d78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601e2d78",
  null
  
)

export default component.exports